import { z } from 'zod/v4';

import { loginDataSchema } from '../login/validation';
import { OtpResponseCode } from '@/enums/response-message/auth';

export const requestDataSchema = z.object({
  app_version: z.string().optional(),
  key: z.string().nullable(),
  login_from: z.string().optional(),
  otp: z.number().nullable(),
  skip_next_time: z.union([z.literal(1), z.literal(0)]),
});

export const responseSuccessSchema = z.object({
  data: loginDataSchema,
  message: z.literal(OtpResponseCode.ATTEMPT_OK),
  success: z.literal(true),
});

export const responseErrorSchema = z.object({
  message: z.union([
    z.literal(OtpResponseCode.ATTEMPT_EXCEEDED_LIMIT),
    z.literal(OtpResponseCode.ATTEMPT_FAILED),
    z.literal(OtpResponseCode.ATTEMPT_NOT_FOUND),
    z.literal(OtpResponseCode.ATTEMPT_EXPIRED),
    z.literal(OtpResponseCode.ATTEMPT_ERROR),
  ]),
  success: z.literal(false),
});
